module.exports = "<header ng-click=\"\n    path.$folded = !path.$folded;\n    foldEditor(['paths', pathName], path.$folded)\"> <h2> <a>{{pathName}}</a> </h2> <a class=jump-to-yaml ng-click=\"focusEdit($event, ['paths', pathName])\" tooltip-placement=left uib-tooltip=\"Jump to YAML\" tooltip-trigger=mouseenter> </a> </header> <ul class=operations collapse-when=path.$folded> <swagger-operation ng-repeat=\"(operationName, operation) in path\" ng-if=\"showOperation(operation, operationName)\"> </swagger-operation> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./templates/path.html
// module id = 569
// module chunks = 0